import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CampaignUpdate } from '../year/forecast-year/CampaignUpdate';
import { CellValue } from 'jspreadsheet-ce';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ForecastYearEditable {
	constructor(private http: HttpClient) {}

	getYearForecast(): Promise<any> {
		return this.http
			.get(`${environment.api}forecast/get_forecast_year_e`)
			.toPromise();
	}

	updateYearForecast(campaignToUpdate: CampaignUpdate) {
		return this.http
			.get(
				`${environment.api}forecast/put_forecast_year_e?id=` +
					campaignToUpdate.id +
					`&growth=` +
					campaignToUpdate.growth +
					`&next_year_leads=` +
					campaignToUpdate.next_year_leads +
					`&lead_cost=` +
					campaignToUpdate.lead_cost,
			)
			.toPromise();
	}

	getMonths(): Promise<any> {
		return this.http
			.get(`${environment.api}forecast/get_forecasted_months`)
			.toPromise();
	}

	getMonthsO(): Observable<any> {
		return this.http.get(
			`${environment.api}forecast/get_forecasted_months`,
		);
	}

	getRealMonthsO(): Observable<any> {
		return this.http.get(`${environment.api}forecast/get_real_months`);
	}

	getLastYearMonthsO(): Observable<any> {
		return this.http.get(`${environment.api}forecast/get_last_year_months`);
	}
}
